<template>
  <v-navigation-drawer
    :value="isDrawerOpen"
    app
    elevation="4"
    width="260"
    class="app-navigation-menu"
    :right="$vuetify.rtl"
    @input="val => $emit('update:is-drawer-open', val)"
  >
    <!-- Navigation Header — hauteur fixe, jamais tronquée -->
    <div class="vertical-nav-header d-flex items-center ps-6 pe-5 pt-3 pb-2">
      <router-link to="/" class="d-flex text-center align-center text-decoration-none">
        <v-slide-x-transition>
          <v-img
            :src="require(`@/assets/images/logos/logo.png`)"
            max-width="150px"
            alt="logo"
            contain
            eager
            class="app-logo me-3"
          />
        </v-slide-x-transition>
      </router-link>
    </div>

    <!--
      ┌─────────────────────────────────────────────────────────────────┐
      │  SCROLL WRAPPER — couvre tout l'espace restant sous le header  │
      │  overflow-y: auto  +  -webkit-overflow-scrolling: touch        │
      │  → contenu défilable sur iOS / Android sans éléments coupés    │
      └─────────────────────────────────────────────────────────────────┘
    -->
    <div class="nav-scroll-area">

      <!-- ═══════════════════════════════════════════════════════════════ -->
      <!-- SAVINGS                                                         -->
      <!-- ═══════════════════════════════════════════════════════════════ -->
      <div v-if="$store.state.isSavings">
        <v-list expand shaped class="vertical-nav-menu-items pr-2">

          <nav-menu-link
            title="Dashboard"
            :to="{ name: 'savings.dashboard' }"
            icon="gauge"
          />

          <!-- Partnership -->
          <nav-menu-group
            title="Partnership"
            icon="hand-holding-hand"
            :notif-categories="['partnership_requests']"
          >
            <nav-menu-link title="Requests"                   :to="{ name: 'savings.partnership_requests' }"              notif-category="partnership_requests" />
            <nav-menu-link title="Make a Withdrawal"          :to="{ name: 'savings.partnership_Make_Withdraw' }" />
            <nav-menu-link title="Withdraw-marketer"          :to="{ name: 'savings.partnership_requests_withdraw' }" />
            <nav-menu-link title="Clients-Partners"           :to="{ name: 'savings.partners_clients' }" />
            <nav-menu-link title="View Marketer Transactions" :to="{ name: 'savings.partnership_withdrawal_transactions' }" />

            <nav-menu-link title="Partners List"              :to="{ name: 'manager.partners.list' }" />
          </nav-menu-group>

          <!-- Business suite -->
            <nav-menu-group
              title="Business Suite"
              icon="fa-building"
              :notif-categories="['business_requests']"
            >
              <nav-menu-link
                title="Requests"
                :to="{ name: 'savings.business_requests' }"
                notif-category="business_requests"
              />

              <nav-menu-link
                title="Business Client List"
                :to="{ name: 'manager.business_suite.list' }"
              />

              <nav-menu-link
                title="Business Commissions"
                :to="{ name: 'savings.business_commissions' }"
              />

              <nav-menu-link
                title="Add Business Videos"
                :to="{ name: 'savings.business_AddBusinessVideos' }"
              />

              <nav-menu-link
                title="Business Transactions"
                :to="{ name: 'savings.business_BussinessTransactions' }"
              />

              <nav-menu-link
                title="Business Videos"
                :to="{ name: 'savings.business_videos' }"
              />

              <nav-menu-link
                title="Business Clients"
                :to="{ name: 'savings.BusinessManagement' }"
              />

              <nav-menu-link
                title="Business Settings"
                :to="{ name: 'savings.BusinessSetting' }"
              />

              <nav-menu-link
                title="Manager Commission Overview"
                :to="{ name: 'savings.business_manager_commissions' }"
              />
            </nav-menu-group>

          <!-- Deposits -->
          <nav-menu-group
            title="Deposits"
            icon="circle-dollar-to-slot"
            :notif-categories="['deposit_requests']"
          >
            <nav-menu-link title="Requests"          :to="{ name: 'savings.deposit_requests' }"     notif-category="deposit_requests" />
            <nav-menu-link title="Validations SMS auto" :to="{ name: 'savings.paiements_auto_validations' }" />
             <nav-menu-link
              title="Payment History"
              :to="{ name: 'savings.payment_history' }"

            />
            <nav-menu-link title="Make a Deposit"    :to="{ name: 'savings.make_deposits' }" />
            <nav-menu-link title="View Transactions" :to="{ name: 'savings.deposit_transactions' }" />
          </nav-menu-group>

          <!-- Withdrawal -->
          <nav-menu-group
            title="Withdrawal"
            icon="money-bill-transfer"
            :notif-categories="['withdrawal_requests']"
          >
            <nav-menu-link title="Requests"              :to="{ name: 'savings.withdrawal_requests' }"     notif-category="withdrawal_requests" />
            <nav-menu-link title="Request a Withdrawal"  :to="{ name: 'savings.request_withdrawal' }" />
            <nav-menu-link title="Make a Withdrawal"     :to="{ name: 'savings.make_withdrawals' }" />
            <nav-menu-link title="View Transactions"     :to="{ name: 'savings.withdrawal_transactions' }" />
          </nav-menu-group>

          <!-- Interrupt -->
          <nav-menu-group
            title="Interrupt"
            icon="ban"
            :notif-categories="['interrupt_requests']"
          >
            <nav-menu-link title="Requests"          :to="{ name: 'savings.interrupt_requests' }"     notif-category="interrupt_requests" />
            <nav-menu-link title="Make an Interrupt" :to="{ name: 'savings.make_interrupt' }" />
            <nav-menu-link title="View Transactions" :to="{ name: 'savings.interrupt_transactions' }" />
          </nav-menu-group>

          <!-- Clients -->
          <nav-menu-group
            title="Clients"
            icon="users"
            :notif-categories="['loan_requests', 'investment_payments']"
          >
            <nav-menu-link title="Summary"                        :to="{ name: 'savings.clients' }" />
            <nav-menu-link title="Create Client"                  :to="{ name: 'savings.create_client' }" />
            <nav-menu-link title="View Zones"                     :to="{ name: 'savings.clients_zones' }" />
            <nav-menu-link title="Create Zone"                    :to="{ name: 'savings.clients_create_zone' }" />
            <nav-menu-link title="Money Transfer"                 :to="{ name: 'savings.clients_transactions' }" />
            <nav-menu-link title="Manage Credit"                  :to="{ name: 'savings.credits' }" />
            <nav-menu-link title="Savings Campaigns"              :to="{ name: 'savings.clients_campaigns' }" />
            <nav-menu-link title="Create Campaign"                :to="{ name: 'savings.clients_create_campaign' }" />
            <nav-menu-link title="Old Loans"                      :to="{ name: 'savings.clients_Old_loans' }" />
            <nav-menu-link title="Loans"                          :to="{ name: 'savings.clients_loans' }"           notif-category="loan_requests" />
            <nav-menu-link title="Create Loan"                    :to="{ name: 'savings.clients_create_loan' }" />
            <nav-menu-link title="Make Investment Payment"        :to="{ name: 'manager.investments.make_payment' }" />
            <nav-menu-link title="Investments"                    :to="{ name: 'manager.investments.list' }" />
            <nav-menu-link title="Validate Investment Payments"   :to="{ name: 'manager.investments.validate' }"    notif-category="investment_payments" />
          </nav-menu-group>

          <!-- Top Ups -->
          <nav-menu-group title="Top Ups" icon="users-gear">
            <nav-menu-link title="Summary"        :to="{ name: 'savings.topup_summary' }" />
            <nav-menu-link title="Create Topup"   :to="{ name: 'savings.topup_create' }" />
            <nav-menu-link title="Reset Password" :to="{ name: 'savings.topup_requested_password' }" />
            <nav-menu-link title="Recharge"       :to="{ name: 'savings.topup_recharge' }" />
            <nav-menu-link title="Transactions"   :to="{ name: 'savings.topup_transactions' }" />
            <nav-menu-link title="Faults"         :to="{ name: 'savings.topup_faults' }" />
            <nav-menu-link
              title="Manage Deposit Blocks"
              :to="{ name: 'savings.manager.deposit_blocks' }"
            />
            <nav-menu-link
              title="Manage Topups"
              :to="{ name: 'savings.manager.topup_accounts' }"
            />
          </nav-menu-group>


          <!-- Cash Flow -->
          <nav-menu-group title="Cash Flow" icon="bank">
            <nav-menu-link title="Profits"             :to="{ name: 'savings.profits_commisions' }"  icon="money-bill-trend-up" />
            <nav-menu-link title="Investments"         :to="{ name: 'savings.investments' }"          icon="business-time" />
            <nav-menu-link title="Employee's Salaries" :to="{ name: 'savings.salaries' }"             icon="money-check-dollar" />
            <nav-menu-link title="Salary Payment"      :to="{ name: 'savings.employees_payments' }"   icon="hand-holding-dollar" />
            <nav-menu-link title="Bills"               :to="{ name: 'savings.bills' }"                icon="file-invoice" />
          </nav-menu-group>

          <nav-menu-link title="Contact Us"       :to="{ name: 'savings.contact_us' }"  icon="comments" />
          <nav-menu-link title="Security Lockouts" :to="{ name: 'SecurityLockouts' }"   icon="shield-halved" notif-category="security_lockouts" />
          <nav-menu-link title="KYC Manager"      :to="{ name: 'savings.kyc_manager' }" icon="id-card" />
          <nav-menu-link title="Chat"             :to="{ name: 'chat.search_chat' }"    icon="comment" />

          <!-- Chatbot AI & Video Suggestions -->
          <nav-menu-group
            title="Chatbot AI Videos"
            icon="fa-video"
          >
            <nav-menu-link
              title="Chatbot Videos"
              :to="{ name: 'manager.chatbot_videos' }"
            />
            <nav-menu-link
              title="Add Chatbot Video"
              :to="{ name: 'manager.add_chatbot_video' }"
            />
          </nav-menu-group>

          <!-- Spacer de sécurité en bas (évite que le dernier item colle au safe-area) -->
          <div class="nav-bottom-spacer" />
        </v-list>
      </div>

      <!-- ═══════════════════════════════════════════════════════════════ -->
      <!-- MARKETPLACE                                                      -->
      <!-- ═══════════════════════════════════════════════════════════════ -->
      <div v-if="$store.state.isMarketPlace">
        <v-list expand shaped class="vertical-nav-menu-items pr-2">
          <nav-menu-link title="Dashboard"              :to="{ name: 'marketplace.dashboard' }"          icon="gauge" />
          <nav-menu-link title="Products"               :to="{ name: 'marketplace.products' }"           icon="cart-plus" />
          <nav-menu-link title="Mobile Payment Request" :to="{ name: 'marketplace.orders.payment' }"     icon="file-invoice-dollar" />
          <nav-menu-link title="Account payment"        :to="{ name: 'marketplace.orders' }"             icon="shopping-basket" />
          <nav-menu-link title="Deliveries"             :to="{ name: 'marketplace.transactions' }"       icon="shopping-cart" />
          <nav-menu-link title="Faults"                 :to="{ name: 'marketplace.faults' }"             icon="file-invoice-dollar" />
          <nav-menu-link title="Profits"                :to="{ name: 'marketplace.profits_commisions' }" icon="money-bill-trend-up" />
          <nav-menu-link title="Campaigns"              :to="{ name: 'marketplace.campaigns' }"          icon="bullhorn" />
          <nav-menu-link title="Contact Us"             :to="{ name: 'marketplace.contact_us' }"         icon="comments" />
          <nav-menu-link title="Chat"                   :to="{ name: 'chat.search_chat' }"               icon="comment" />

          <nav-menu-section-title title="Seller Management" />
          <nav-menu-link title="Seller Overview"     :to="{ name: 'market_place.seller_management' }"   icon="store"         notif-category="seller_events" />
          <nav-menu-link title="Seller Applications" :to="{ name: 'market_place.seller_applications' }" icon="file-invoice"  notif-category="seller_applications" />

          <div class="nav-bottom-spacer" />
        </v-list>
      </div>

      <!-- ═══════════════════════════════════════════════════════════════ -->
      <!-- NJANGI                                                           -->
      <!-- ═══════════════════════════════════════════════════════════════ -->
      <div v-if="$store.state.isNjangi">
        <v-list expand shaped class="vertical-nav-menu-items pr-2">
          <nav-menu-link title="Dashboard" :to="{ name: 'njangi.dashboard' }" icon="gauge" />

          <nav-menu-group
            title="Groups"
            icon="users"
            :notif-categories="['njangi_pending_groups', 'njangi_join_requests']"
          >
            <nav-menu-link title="Pending Groups"       :to="{ name: 'njangi.pending_groups' }"   notif-category="njangi_pending_groups" />
            <nav-menu-link title="Join Requests"        :to="{ name: 'njangi.join_requests' }"    notif-category="njangi_join_requests" />
            <nav-menu-link title="Add New Njangi Group" :to="{ name: 'njangi.create_group' }" />
            <nav-menu-link title="Accept User To Njangi" :to="{ name: 'njangi.accept_requests' }" notif-category="njangi_join_requests" />
            <nav-menu-link title="View Groups"          :to="{ name: 'njangi.view_groups' }" />
            <nav-menu-link title="Manage Contributions" :to="{ name: 'njangi.Manage_groups' }" />
            <nav-menu-link
              v-if="$route.name === 'njangi.edit_group'"
              title="Edit Group"
              :to="{ name: 'njangi.edit_group', params: { id: $route.params.id } }"
              icon="pen"
            />
          </nav-menu-group>

          <nav-menu-group
            title="Deposits"
            icon="circle-dollar-to-slot"
            :notif-categories="['njangi_contribution_requests', 'njangi_collector_payments']"
          >
            <nav-menu-link title="Requests"             :to="{ name: 'njangi.contribution_requests' }"    notif-category="njangi_contribution_requests" />
            <nav-menu-link title="Make a Contribution"  :to="{ name: 'njangi.make_contribution' }" />
            <nav-menu-link title="Collector Payment"    :to="{ name: 'njangi.collector_payment' }"       notif-category="njangi_collector_payments" />  
            <nav-menu-link title="View Transactions"    :to="{ name: 'njangi.contribution_transactions' }" />
          </nav-menu-group>

          <nav-menu-link title="Contact Us" :to="{ name: 'njangi.contact_us' }" icon="comments" />
          <nav-menu-link title="Chat"       :to="{ name: 'chat.search_chat' }"  icon="comment" />

          <div class="nav-bottom-spacer" />
        </v-list>
      </div>

      <!-- ═══════════════════════════════════════════════════════════════ -->
      <!-- FUNDRAISING                                                      -->
      <!-- ═══════════════════════════════════════════════════════════════ -->
      <div v-if="$store.state.isFundraising">
        <v-list expand shaped class="vertical-nav-menu-items pr-2">
          <nav-menu-link title="Dashboard"    :to="{ name: 'njangi.dashboard' }"              icon="gauge" />
          <nav-menu-link title="Projects"     :to="{ name: 'njangi.njangilist' }"             icon="project-diagram" />
          <nav-menu-link title="Events"       :to="{ name: 'njangi.eventlist' }"              icon="calendar-alt" />
          <nav-menu-link title="Transactions" :to="{ name: 'njangi.transactions' }"           icon="money-bill-transfer" />
          <nav-menu-link title="My Faults"    :to="{ name: 'njangi.my_faults' }"              icon="file-invoice-dollar" />
          <nav-menu-link title="Deposits"     :to="{ name: 'njangi.deposits' }"               icon="circle-dollar-to-slot" />
          <nav-menu-link title="Withdrawals"  :to="{ name: 'njangi.requested_withdrawals' }"  icon="cash-register" />
          <nav-menu-link title="Contact Us"   :to="{ name: 'njangi.contact_us' }"             icon="comments" />
          <nav-menu-link title="Chat"         :to="{ name: 'chat.search_chat' }"              icon="comment" />

          <div class="nav-bottom-spacer" />
        </v-list>
      </div>

      <!-- ═══════════════════════════════════════════════════════════════ -->
      <!-- MONITOR                                                          -->
      <!-- ═══════════════════════════════════════════════════════════════ -->
      <div v-if="$store.state.isMonitor">
        <v-list expand shaped class="vertical-nav-menu-items pr-2">
          <nav-menu-link title="Dashboard"          :to="{ name: 'njangi.dashboard' }"          icon="gauge" />
          <nav-menu-link title="Users"              :to="{ name: 'njangi.deposits' }"            icon="users" />
          <nav-menu-link title="My Follow Ups"      :to="{ name: 'njangi.requested_withdrawals' }" icon="money-bill-transfer" />
          <nav-menu-link title="Analytics"          :to="{ name: 'savings.manager_analytics' }" icon="chart-line" />
          <nav-menu-link title="campaign-migration" :to="{ name: 'savings.campaign_migration' }" icon="chart-line" />

          <nav-menu-group title="Marketing" icon="chart-column">
            <nav-menu-link title="Resources" :to="{ name: 'njangi.marketing_resources' }" />
            <nav-menu-link title="Prospects" :to="{ name: 'njangi.marketing_prospects' }" />
          </nav-menu-group>

          <nav-menu-link title="Contact Us"        :to="{ name: 'njangi.contact_us' }"  icon="comments" />
          <nav-menu-link title="Security Lockouts" :to="{ name: 'SecurityLockouts' }"   icon="shield-halved" notif-category="security_lockouts" />
          <nav-menu-link title="Chat"              :to="{ name: 'chat.search_chat' }"   icon="comment" />
          <nav-menu-link title="Tasks" :to="{ name: 'monitor.tasks' }" icon="clipboard" />

          <!-- Chatbot AI & Video Suggestions -->
          <nav-menu-group
            title="Chatbot AI Videos"
            icon="fa-video"
          >
            <nav-menu-link
              title="Chatbot Videos"
              :to="{ name: 'manager.chatbot_videos' }"
            />
            <nav-menu-link
              title="Add Chatbot Video"
              :to="{ name: 'manager.add_chatbot_video' }"
            />
          </nav-menu-group>

          <div class="nav-bottom-spacer" />
        </v-list>
      </div>

      <!-- ═══════════════════════════════════════════════════════════════ -->
      <!-- BUSINESS ACCOUNT                                                 -->
      <!-- ═══════════════════════════════════════════════════════════════ -->
      <div v-if="$store.state.isBusiness_account">
        <v-list expand shaped class="vertical-nav-menu-items pr-2">
          <nav-menu-link title="Dashboard" :to="{ name: 'business-account.dashboard' }" icon="gauge" />

          <nav-menu-group
            title="Partnership"
            icon="hand-holding-hand"
            :notif-categories="['partnership_requests']"
          >
            <nav-menu-link title="Requests"         :to="{ name: 'savings.partnership_requests' }" notif-category="partnership_requests" />
            <nav-menu-link title="Clients-Partners" :to="{ name: 'savings.partners_clients' }" />
          </nav-menu-group>

          <nav-menu-group
            title="Deposits"
            icon="circle-dollar-to-slot"
            :notif-categories="['deposit_requests']"
          >
            <nav-menu-link title="Requests"          :to="{ name: 'savings.deposit_requests' }"     notif-category="deposit_requests" />
            <nav-menu-link title="Make a Deposit"    :to="{ name: 'savings.make_deposits' }" />
            <nav-menu-link title="View Transactions" :to="{ name: 'savings.deposit_transactions' }" />
          </nav-menu-group>

          <nav-menu-group
            title="Withdrawal"
            icon="money-bill-transfer"
            :notif-categories="['withdrawal_requests']"
          >
            <nav-menu-link title="Requests"             :to="{ name: 'savings.withdrawal_requests' }"     notif-category="withdrawal_requests" />
            <nav-menu-link title="Request a Withdrawal" :to="{ name: 'savings.request_withdrawal' }" />
            <nav-menu-link title="Make a Withdrawal"    :to="{ name: 'savings.make_withdrawals' }" />
            <nav-menu-link title="View Transactions"    :to="{ name: 'savings.withdrawal_transactions' }" />
          </nav-menu-group>

          <nav-menu-group
            title="Interrupt"
            icon="ban"
            :notif-categories="['interrupt_requests']"
          >
            <nav-menu-link title="Requests"          :to="{ name: 'savings.interrupt_requests' }"     notif-category="interrupt_requests" />
            <nav-menu-link title="Make an Interrupt" :to="{ name: 'savings.make_interrupt' }" />
            <nav-menu-link title="View Transactions" :to="{ name: 'savings.interrupt_transactions' }" />
          </nav-menu-group>

          <nav-menu-group
            title="Clients"
            icon="users"
            :notif-categories="['loan_requests']"
          >
            <nav-menu-link title="Summary"          :to="{ name: 'savings.clients' }" />
            <nav-menu-link title="Create Client"    :to="{ name: 'savings.create_client' }" />
            <nav-menu-link title="View Zones"       :to="{ name: 'savings.clients_zones' }" />
            <nav-menu-link title="Create Zone"      :to="{ name: 'savings.clients_create_zone' }" />
            <nav-menu-link title="Savings Campaign" :to="{ name: 'savings.clients_campaigns' }" />
            <nav-menu-link title="Create Campaign"  :to="{ name: 'savings.clients_create_campaign' }" />
            <nav-menu-link title="Loans"            :to="{ name: 'savings.clients_loans' }"         notif-category="loan_requests" />
            <nav-menu-link title="Create Loan"      :to="{ name: 'savings.clients_create_loan' }" />
          </nav-menu-group>

          <nav-menu-group title="Top Ups" icon="users-gear">
            <nav-menu-link title="Summary"        :to="{ name: 'savings.topup_summary' }" />
            <nav-menu-link title="Create Topup"   :to="{ name: 'savings.topup_create' }" />
            <nav-menu-link title="Reset Password" :to="{ name: 'savings.topup_requested_password' }" />
            <nav-menu-link title="Recharge"       :to="{ name: 'savings.topup_recharge' }" />
            <nav-menu-link title="Transactions"   :to="{ name: 'savings.topup_transactions' }" />
            <nav-menu-link title="Faults"         :to="{ name: 'savings.topup_faults' }" />
            <nav-menu-link
            title="Manage Deposit Blocks"
            :to="{ name: 'savings.manager.deposit_blocks' }"
          />
          </nav-menu-group>

          <nav-menu-group title="Cash Flow" icon="bank">
            <nav-menu-link title="Profits"             :to="{ name: 'savings.profits_commisions' }"  icon="money-bill-trend-up" />
            <nav-menu-link title="Investments"         :to="{ name: 'savings.investments' }"          icon="business-time" />
            <nav-menu-link title="Employee's Salaries" :to="{ name: 'savings.salaries' }"             icon="money-check-dollar" />
            <nav-menu-link title="Salary Payment"      :to="{ name: 'savings.employees_payments' }"   icon="hand-holding-dollar" />
            <nav-menu-link title="Bills"               :to="{ name: 'savings.bills' }"                icon="file-invoice" />
          </nav-menu-group>

          <nav-menu-link title="Contact Us"        :to="{ name: 'savings.contact_us' }" icon="comments" />
          <nav-menu-link title="Security Lockouts" :to="{ name: 'SecurityLockouts' }"   icon="shield-halved" notif-category="security_lockouts" />
          <nav-menu-link title="Chat"              :to="{ name: 'chat.search_chat' }"   icon="comment" />

          <div class="nav-bottom-spacer" />
        </v-list>
      </div>

    </div><!-- /nav-scroll-area -->
  </v-navigation-drawer>
</template>

<script>
import NavMenuLink  from './components/NavMenuLink.vue'
import NavMenuGroup from './components/NavMenuGroup.vue'

export default {
  components: {
    NavMenuLink,
    NavMenuGroup,
  },

  props: {
    isDrawerOpen: {
      type: Boolean,
      default: null,
    },
  },

  data() {
    return {
      _pollingTimer: null,
    }
  },

  mounted() {
    this._startPolling()
  },

  beforeDestroy() {
    this._stopPolling()
  },

  methods: {
    _startPolling() {
      if (!this.$store.state.isAuthenticated) return
      this.$store.dispatch('fetchNotificationCounts')
      this._pollingTimer = setInterval(() => {
        this.$store.dispatch('fetchNotificationCounts')
      }, 60000)
    },

    _stopPolling() {
      if (this._pollingTimer) {
        clearInterval(this._pollingTimer)
        this._pollingTimer = null
      }
    },
  },
}
</script>

<style lang="scss" scoped>

/* ─── Header ─────────────────────────────────────────────────────────── */
.vertical-nav-header {
  /* hauteur fixe pour que le calcul de hauteur du scroll-area soit stable */
  flex-shrink: 0;
}

/* ─── Zone de scroll principale ──────────────────────────────────────── */
/*
  Le v-navigation-drawer de Vuetify crée déjà un flex-column en interne.
  .nav-scroll-area prend tout l'espace restant et gère le scroll lui-même,
  ce qui évite que le navigateur coupe les derniers items.
*/
.nav-scroll-area {
  flex: 1 1 auto;          /* remplit l'espace disponible sous le header  */
  min-height: 0;           /* autorise le rétrécissement dans le flex     */
  overflow-y: auto;        /* scroll vertical si le contenu dépasse       */
  overflow-x: hidden;      /* jamais de scroll horizontal                 */

  /* Scroll fluide sur iOS (momentum scrolling) */
  -webkit-overflow-scrolling: touch;

  /* Empêche le scroll de "passer" à la page parente sur mobile */
  overscroll-behavior: contain;

  /* Seul le scroll vertical est autorisé (pas de conflit avec le drawer) */
  touch-action: pan-y;

  /* Respect de la safe-area iOS (notch, home indicator) */
  padding-bottom: env(safe-area-inset-bottom, 16px);

  /* Scrollbar discrète : Firefox */
  scrollbar-width: thin;
  scrollbar-color: rgba(0, 71, 155, 0.28) transparent;

  /* Scrollbar discrète : Chrome/Edge/Safari */
  &::-webkit-scrollbar {
    width: 6px;
  }
  &::-webkit-scrollbar-track {
    background: transparent;
  }
  &::-webkit-scrollbar-thumb {
    background: rgba(0, 71, 155, 0.28);
    border-radius: 6px;
    &:hover {
      background: rgba(0, 71, 155, 0.45);
    }
  }
}

/* ─── Spacer de sécurité en fin de liste ─────────────────────────────── */
/*
  Ajoute un espace supplémentaire sous le dernier item pour que
  le dernier lien soit bien visible même avec la barre de navigation
  du navigateur ou le home indicator d'iOS.
*/
.nav-bottom-spacer {
  height: max(env(safe-area-inset-bottom, 0px), 24px);
}

/* ─── Thème ───────────────────────────────────────────────────────────── */
.app-title {
  font-size: 1.25rem;
  font-weight: 700;
  font-stretch: normal;
  font-style: normal;
  line-height: normal;
  letter-spacing: 0.3px;
}

.app-logo {
  transition: all 0.18s ease-in-out;
  .v-navigation-drawer--mini-variant & {
    transform: translateX(-4px);
  }
}

@include theme(app-navigation-menu) using ($material) {
  background-color: map-deep-get($material, 'background');
}

.app-navigation-menu {
  /* S'assurer que le drawer lui-même utilise flex-column */
  ::v-deep .v-navigation-drawer__content {
    display: flex;
    flex-direction: column;
    height: 100%;
    overflow: hidden; /* le scroll est délégué à .nav-scroll-area */
  }

  .v-list-item {
    &.vertical-nav-menu-link {
      ::v-deep .v-list-item__icon {
        .v-icon {
          transition: none !important;
        }
      }
    }
  }
}

/* ─── Responsive mobile ─────────────────────────────────────────────── */
/*
  Sur mobile le drawer occupe presque toute la largeur de l'écran
  (mais jamais plus de ~300px) pour rester lisible, et le header
  est resserré pour laisser plus de place au scroll.
*/
@media (max-width: 600px) {
  .app-navigation-menu {
    width: 88vw !important;
    max-width: 300px;
  }

  .vertical-nav-header {
    padding-left: 1rem !important;
    padding-right: 0.75rem !important;
    padding-top: 0.5rem !important;
    padding-bottom: 0.5rem !important;

    .v-slide-x-transition {
      width: 100%;
    }

    .app-logo {
      max-width: 130px;
    }
  }
}
</style>
